<template>
    <dashboard-layout title="근로계약서 관리" fullHeight topBtn>
        <template slot="contents">
            <div class="mb-20 mb-lg-40" style="flex: 0 0 auto;">
                <v-badge floating dot>
                    <h4 class="tit--sm line-height-1">계약서 목록</h4>
                </v-badge>
            </div>

            <template v-if="contracts.length">
                <v-row>
                    <template v-for="value in items">
                        <v-col cols="12" lg="6" :key="value?._id">
                            <employment-contract-item
                                v-bind="{
                                    value,
                                }"
                                v-on="{
                                    search,
                                }"
                            />
                        </v-col>
                    </template>
                </v-row>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-16" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>

            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요. <br />
                        계약서가 없습니다.
                    </p>
                    <v-btn href="/recruitments" text height="auto" color="transparent">
                        <span class="grey-9--text">채용공고 지원하기</span>
                    </v-btn>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import EmploymentContractItem from "@/components/dashboard/person/employment/contract/employment-contract-item.vue";

export default {
    components: {
        DashboardLayout,
        EmploymentContractItem,
    },
    data: () => ({
        contracts: [],
        summary: { totalCount: 0 },

        limit: 10,
        loading: false,
    }),
    computed: {
        items() {
            return this.contracts.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            delete query.page;

            return { ...query };
        },
    },
    mounted() {
        this.init().then(this.search);
    },
    watch: {
        params() {
            this.init().then(this.search);
        },
        limit() {
            this.init().then(this.search);
        },
    },
    methods: {
        async init() {
            this.contracts = [];
            this.summary = { totalCount: 0 };
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { skip, limit, params } = this;
                const { summary, contracts } = await api.v1.person.employment.contracts.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.contracts = contracts;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
